
import React from 'react';
import { 
  PlusCircle, 
  Filter,
  RefreshCw
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface RentalActionsProps {
  onAddClick: () => void;
  onStatusFilterChange: (status: string | null) => void;
  onRefresh: () => void;
  dataSource: 'supabase' | 'mock';
}

export const RentalActions: React.FC<RentalActionsProps> = ({
  onAddClick,
  onStatusFilterChange,
  onRefresh,
  dataSource
}) => {
  return (
    <div className="flex space-x-2">
      {dataSource === 'mock' && (
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Повторить подключение
        </Button>
      )}
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm">
            <Filter className="mr-2 h-4 w-4" />
            Фильтр
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={() => onStatusFilterChange(null)}>
              Все статусы
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onStatusFilterChange('active')}>
              Активные
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onStatusFilterChange('completed')}>
              Завершенные
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onStatusFilterChange('cancelled')}>
              Отмененные
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <Button size="sm" onClick={onAddClick}>
        <PlusCircle className="mr-2 h-4 w-4" />
        Оформить аренду
      </Button>
    </div>
  );
};
